import { backendConfig } from "../../config/BackendConfig";

export const serviceToolTabKeys = {
  deviceInfo: "deviceInfo",
  deviceSetup: "deviceSetup",
  diagnostics: "diagnostics",
  faultConfiguration: "faultConfiguration",
  logs: "logs",
};

export const isServiceToolShow = () =>
  ["DEV"].includes(backendConfig.CURRENT_ENV);

export const modeVal = {
  STANDBY: "standBy",
  SENSE_ONLY: "senseOnly",
  OPERATIONAL: "operational",
  RESEARCH: "research",
};

export const modes = {
  standBy: "STANDBY",
  senseOnly: "SENSE_ONLY",
  operational: "OPERATIONAL",
  research: "RESEARCH",
};

export const cartridgeColor = (level, mode) => {
  if (mode === "OFFLINE") {
    return "#8C8C8C";
  }
  if (level) {
    if (level < 10) {
      return "#FF2B02";
    } else if (level < 20) {
      return "#FFD012";
    } else {
      return "#07D95A";
    }
  }
  return "#F0F0F0";
};

export const getDeviceLocation = (dLocation) => {
  if (dLocation) {
    const deviceLocation = dLocation.split("#");

    if (deviceLocation.length === 2) {
      // To Check if there is only one "#" character
      return "";
    } else {
      const remainingLocation = deviceLocation.slice(2); // To ignore the Tenant and Site Id
      const joinedLocation = remainingLocation.join("/"); // To join the remaining parts
      return joinedLocation;
    }
  }
};

export const formateWithToFixed = (val) => {
  let num = +val;
  return isNaN(num) ? "0.00" : num > 0 ? num.toFixed(2) : "0.00";
};

export const beforeAfterDecimal = (val, mode) => {
  if (mode === "OFFLINE" || mode === "STANDBY" || mode === undefined) {
    return { before: "--- ", after: "" };
  }
  let [before, after] = val.toString().split(".");
  return { before: `${before}.`, after };
};

export function convertMilliseconds(timeInMs) {
  const millisecondsInSecond = 1000;
  const millisecondsInMinute = millisecondsInSecond * 60;
  const millisecondsInHour = millisecondsInMinute * 60;

  // Calculate hours
  const hours = Math.floor(timeInMs / millisecondsInHour);
  const remainderAfterHours = timeInMs % millisecondsInHour;

  // Calculate minutes
  const minutes = Math.floor(remainderAfterHours / millisecondsInMinute);
  const remainderAfterMinutes = remainderAfterHours % millisecondsInMinute;

  // Calculate seconds
  const seconds = Math.floor(remainderAfterMinutes / millisecondsInSecond);
  const remainderAfterSeconds = remainderAfterMinutes % millisecondsInSecond;

  // Optional: Convert milliseconds to display format (e.g., 2.345 seconds)
  const milliseconds = remainderAfterSeconds;

  return {
    hours,
    minutes,
    seconds,
    milliseconds,
  };
}

export const formatingTime = (val) => {
  let strLength = val?.toString()?.length;
  if (strLength === 1) {
    return `0${val}`;
  }
  return val;
};
